/* this file added by Bearer Web Developer  */
import React from "react";
import { Button, Dialog } from "@mui/material";
import { observer } from "mobx-react-lite";
import styles from './switchConfirmPopup.module.scss';
import { useAppState } from "../../../../states/app-state";

interface ISwitchConfirmPopup { open: boolean, handleClose: () => void, handleOpenToast: () => void }
const SwitchConfirmPopup: React.FC<ISwitchConfirmPopup> = observer(({ open, handleClose, handleOpenToast }) => {
    const appState = useAppState();
    const switchPlace = appState.selectedOrder?.switchPlace;
    const origin = appState.selectedOrder?.origin;
    const destination = appState.selectedOrder?.destination;
    const handleSwitchPlace = () => {

        appState.selectedOrder?.setSwitchPlace(!switchPlace);
        if (origin?.address && destination?.address) {
            const origin_address = {
                description: destination?.address?.description,
                location: { lat: destination?.address?.location?.lat, lng: destination?.address?.location?.lng }
            };
            const destination_address = {
                description: origin?.address?.description,
                location: { lat: origin?.address?.location?.lat, lng: origin?.address?.location?.lng }
            };
            origin?.setAddress(origin_address);
            destination?.setAddress(destination_address);
            handleOpenToast();
            handleClose();
        }
    }
    // modified by Bearer Web Developer start
    return (
        <Dialog PaperProps={{ style: { borderRadius: "10px" } }}
            open={open}
            onClose={handleClose}

        >
            <div className={styles.switch_confirm_popup}>
                <p>Switching will swap your origin and destination. Are you sure?</p>
                <div className={styles.confirm}>
                    <Button onClick={handleClose} disableRipple={true} className={styles.no}><span>No</span></Button>
                    <Button onClick={handleSwitchPlace} disableRipple={true} className={styles.yes}><span>Yes</span></Button>
                </div>
            </div>
        </Dialog>
    );
    // modified by Bearer Web Developer end
})
export default SwitchConfirmPopup;